module.exports = __webpack_public_path__ + "static/img/wear_detect2.cb4849b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus3/wear_detect2.gif
// module id = ujfu
// module chunks = 1